import 'mobx-react/batchingForReactDom'

import './src/styles/global.css'
